"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const BooleanInputPopover_module_scss_1 = __importDefault(require("./BooleanInputPopover.module.scss"));
const react_popper_1 = require("react-popper");
const PopoverSharedStyle_module_scss_1 = __importDefault(require("./PopoverSharedStyle.module.scss"));
const react_i18next_1 = require("react-i18next");
const BooleanInputPopover = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [popover, setPopover] = (0, react_1.useState)(null);
    const [popperElement, setPopperElement] = (0, react_1.useState)(null);
    const { styles, attributes } = (0, react_popper_1.usePopper)(popover, popperElement, {});
    const [popoverActive, setPopoverActive] = (0, react_1.useState)(false);
    const onOpenPopover = () => {
        setPopoverActive(true);
    };
    let styleClass = "";
    switch (props.type) {
        case "danger":
            styleClass = BooleanInputPopover_module_scss_1.default.danger;
    }
    const onBooleanButtonClick = (response) => {
        props.onBooleanSubmit(response);
        setPopoverActive(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.children(setPopover, onOpenPopover),
        react_1.default.createElement("div", Object.assign({ className: [
                PopoverSharedStyle_module_scss_1.default.popover,
                BooleanInputPopover_module_scss_1.default.popover,
                popoverActive ? PopoverSharedStyle_module_scss_1.default.active : "",
                styleClass,
            ].join(" "), ref: setPopperElement, style: styles.popper }, attributes.popper),
            react_1.default.createElement("p", null, props.prompt),
            react_1.default.createElement("div", { className: BooleanInputPopover_module_scss_1.default.buttons },
                react_1.default.createElement("button", { type: "button", onClick: () => onBooleanButtonClick(false) }, t("root.no")),
                react_1.default.createElement("button", { type: "button", onClick: () => onBooleanButtonClick(true) }, t("root.yes")))),
        react_1.default.createElement("div", { className: `${PopoverSharedStyle_module_scss_1.default.backdrop} ${popoverActive ? PopoverSharedStyle_module_scss_1.default.active : ""}`, onClick: () => {
                setPopover(null);
                setPopoverActive(false);
            } })));
};
exports.default = BooleanInputPopover;
//# sourceMappingURL=BooleanInputPopover.js.map